import React, { PureComponent } from 'react'
import Overlay from 'views/overlay/overlay'
import { connect } from 'react-redux'
import { localize } from 'helpers/translator'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import myLibraryActions from 'redux/actions/my_library_actions'
import myLibrarySubOverlaySelector from 'redux/selectors/my_library/my_library_sub_overlay_selector'

import subIcon from 'assets/overlays/sub_plan_icon.svg'

class SubsOverlay extends PureComponent {

	componentDidMount() {
		this.props.actions.overlaySubsInitialize()
	}

	onLearnMore = () => {
		this.props.actions.overlaySubsOnLearnMore(this.props.hasVisitedSubplans)
	}

	onButtonDismiss = () => {
		this.props.actions.overlaySubsDismiss()
	}

	componentWillUnmount() {
		this.props.actions.overlaySubsClosed()
	}

	render() {
		const key = this.props.hasVisitedSubplans ? 'subs_GoToDashboard' : 'learn_more'
		const buttonOne = {text: localize(key), action: this.onLearnMore }
		const buttonDismiss = { text: localize('action_button_nothanks'), action: this.onButtonDismiss }

		return <Overlay
			offerTitle={localize('subs_overlay_title')}
			offerMessage={localize('subs_overlay_body')}
			buttonOne={buttonOne}
			buttonDismiss={buttonDismiss}
			imgIcon={subIcon} />
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		overlaySubsOnLearnMore: myLibraryActions.overlaySubsOnLearnMore,
		overlaySubsDismiss: myLibraryActions.overlaySubsDismiss,
		overlaySubsClosed: myLibraryActions.overlaySubsClosed,
		overlaySubsInitialize: myLibraryActions.overlaySubsInitialize,
	}, dispatch)
}

function mapStateToProps(state) {
	return myLibrarySubOverlaySelector(state)
}

export default connect(mapStateToProps, mapDispatchToProps)(SubsOverlay)

export { SubsOverlay }
